export default "__VITE_ASSET__Cu4ij9VQ__"